var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"carousel-button",on:{"click":function($event){return _vm.$emit('click', _vm.verifiedType)}}},[_c('img',{attrs:{"src":_vm.arrowIcon,"alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }